import React from 'react';
import { AppointmentRecurring } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { MobileDropdown } from '../../../../Inputs';

export const useRepetitionOptions = () => {
  const l10n = useL10n();

  return React.useMemo(() => [
    {
      value: AppointmentRecurring.none,
      label: l10n.schedule.createAppointment.recurringOptions.none,
    },
    {
      value: AppointmentRecurring.weekly,
      label:
        l10n.schedule.createAppointment.recurringOptions.weekly,
    },
    {
      value: AppointmentRecurring.biweekly,
      label:
        l10n.schedule.createAppointment.recurringOptions.biweekly,
    },
    {
      value: AppointmentRecurring.monthly,
      label:
        l10n.schedule.createAppointment.recurringOptions.monthly,
    },
  ], [ l10n.schedule.createAppointment.recurringOptions ]);
};


export type AppointmentRepetitionSelectProps = {
  name: string;
  label?: string;
  disabled?: boolean;
};

export const AppointmentRepetitionSelect: React.FC<AppointmentRepetitionSelectProps> = (props) => {
  const items = useRepetitionOptions();

  return (
    <MobileDropdown {...props} items={items} />
  );
};
